/**
 *
 * Asynchronously loads the component for CreateUserTrainingPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserTrainingDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.TrainingDetailsPage,
);
